/**
 * Card #566 (Asim, card #27 review): the Items API sends a stable `code` (and its `params`) next to
 * its English `message` (shared-services, card #565). The screen shows that code's EN/ES/FR text
 * (API_ERRORS.<code> in src/assets/i18n), and the API's English message when the code has none.
 */
export interface InstantTranslator {
  instant(key: string, params?: Record<string, unknown>): unknown;
}

export function apiErrorText(body: unknown, translate?: InstantTranslator | null): string {
  const b = (body ?? {}) as { code?: unknown; params?: unknown; message?: unknown; error?: unknown };
  const fallback = typeof b.message === 'string' && b.message ? b.message : typeof b.error === 'string' ? b.error : '';
  if (!translate || typeof b.code !== 'string' || !/^[A-Z][A-Z0-9_]*$/.test(b.code)) {
    return fallback;
  }
  const key = `API_ERRORS.${b.code}`;
  const params = b.params && typeof b.params === 'object' ? (b.params as Record<string, unknown>) : {};
  const text = translate.instant(key, params);
  return typeof text === 'string' && text && text !== key ? text : fallback;
}
